// Thomas Jefferson University's undergraduate majors (#2839). Read on
// 2026-10-01 from the official 2026-2027 Academic Catalog's Undergraduate
// Programs table (catalog.jefferson.edu/academic-programs/undergraduate-
// programs/, read in a headless browser because the catalog answers plain
// requests with an empty 202). The table lists each program with its
// degree, campus, format and college; every bachelor's line is kept and
// grouped by its college. Left out: associate degrees (Radiologic
// Technology AS, Paramedicine AS, Occupational Therapy ASOT) and the
// certificate lines (EMX, HINX, MBCX). Rows the table repeats (Accounting,
// Finance, Management, Marketing twice; Business Administration once on
// campus and once online; Human Resource Management twice online, once
// misspelled) are listed once, with a note when a program is online. The table's typos are corrected:
// "Humanites" to Humanities, "Fashion & Texxtile (CF&T)" to "Fashion and Textiles" (the college's
// name on the catalog's Colleges & Schools menu), "Mnaagement" to
// Management, "Institute for" to "Institute of" Emerging Health Professions
// (as the menu names it). "Health Sciences: Pre-Nursing (BS)" carries BSN in the
// table's degree column; the degree here follows the program's own title.
// Campus notes: programs are on the East Falls campus unless noted.
const majors = {
    "slug": "thomas-jefferson-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Jefferson's official 2026-2027 Academic Catalog, grouped by the college that offers it, with the degree it leads to. Programs are on the East Falls campus unless a note says otherwise. Associate degrees, certificates, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Humanities & Sciences",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Biopsychology",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS",
                    "note": "On campus or online"
                },
                {
                    "name": "Communication & Media Strategies",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BS"
                },
                {
                    "name": "Law & Society",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Design and Engineering",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Animation & Digital Media",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Graphic Design & Visual Communication",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Institute of Emerging Health Professions",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Behavioral & Health Services",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Emergency Management",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Health Insurance Management",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Health Sciences: Health Professions Pathways",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Health Services Management",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Health Studies",
                    "degree": "BS",
                    "note": "Online"
                }
            ]
        },
        {
            "name": "College of Life Sciences",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Pre-Medical Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health Professions",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Biotechnology",
                    "degree": "BS",
                    "note": "East Falls and Center City campuses"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences: Pre-Medical Imaging/Radiation Sciences",
                    "degree": "BS",
                    "note": "East Falls and Center City campuses"
                },
                {
                    "name": "Health Sciences: Pre-Medical Lab Sci/Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences: Pre-Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences: Pre-Pharmacy",
                    "degree": "BS",
                    "note": "East Falls and Center City campuses"
                },
                {
                    "name": "Health Sciences: Pre-Physician Assistant",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences: Pre-Respiratory Therapy",
                    "degree": "BS",
                    "note": "East Falls and Center City campuses"
                },
                {
                    "name": "Medical Imaging & Radiation Sciences",
                    "degree": "BS",
                    "note": "Center City campus"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS",
                    "note": "Center City campus"
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "BS",
                    "note": "Online, Center City campus"
                }
            ]
        },
        {
            "name": "College of Rehabilitation Sciences",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Fashion and Textiles",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Fashion Design",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Merchandising & Management",
                    "degree": "BS"
                },
                {
                    "name": "Textile Design",
                    "degree": "BS"
                },
                {
                    "name": "Textile Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Jefferson 2026-2027 Academic Catalog, Undergraduate Programs",
                "url": "https://catalog.jefferson.edu/academic-programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN",
                    "note": "Dixon campus"
                },
                {
                    "name": "Nursing RN to BSN",
                    "degree": "BSN",
                    "note": "Online, through Center City and partner institutions"
                }
            ]
        }
    ]
};

export default majors;
